/** Скільки горизонтів лишилося переписати. Один запит, для «чи є що робити». */
export async function countHorizonsToRemap(db, horizonId) {
    const rows = await db.query("SELECT id, kind, key FROM horizon");
    return rows.filter((r) => r.id !== horizonId(r.kind, r.key)).length;
}
/**
 * Переписує все, що лишилося. Безпечно викликати повторно й безпечно
 * переривати.
 *
 * Кожен горизонт — окрема транзакція, а не одна велика на весь архів.
 * Причина в транспорті: кожен запит до бази у вебі — це обмін із воркером,
 * і одна транзакція на тисячі горизонтів тримала б базу замкненою всі ці
 * обміни. Дрібні транзакції ще й дають природну точку відновлення.
 */
export async function remapHorizonIds(db, horizonId, onProgress) {
    const rows = await db.query("SELECT id, kind, key FROM horizon");
    // Ідентифікатор рахується один раз на рядок і несеться далі: другий
    // виклик тієї самої функції — це не лише зайвий SHA-256, а ще й друге
    // місце, де вона може дати інший результат.
    const pending = rows
        .map((row) => ({ row, next: horizonId(row.kind, row.key) }))
        .filter(({ row, next }) => row.id !== next);
    let done = 0;
    onProgress?.({ done, total: pending.length });
    for (const { row, next } of pending) {
        await db.transaction(async (tx) => {
            await tx.exec("PRAGMA defer_foreign_keys = ON");
            await remapOne(tx, row.id, next);
        });
        done += 1;
        onProgress?.({ done, total: pending.length });
    }
    return done;
}
/**
 * Перенести один горизонт на новий ідентифікатор **усередині вже
 * відкритої транзакції**.
 *
 * Окремо від `remapHorizonIds`, бо той самий крок потрібен
 * перешифруванню архіву на чужий ключ ([ADR-0026]) — а воно робиться
 * однією транзакцією на весь архів і вкладеної відкрити не може.
 *
 * ⚠️ Викликач **зобовʼязаний** увімкнути `PRAGMA defer_foreign_keys`.
 * `horizon_item.horizon_id` посилається на `horizon(id)` без
 * `ON UPDATE CASCADE`, а зовнішні ключі увімкнені: змінити батька, поки
 * на нього дивляться діти, — порушення; змінити дітей на ще не існуючий
 * ідентифікатор — теж. Виходу немає, крім відкладеної перевірки, і вона
 * діє до кінця транзакції.
 */
export async function remapOne(tx, from, to) {
    await tx.exec("UPDATE horizon_item SET horizon_id = ? WHERE horizon_id = ?", [to, from]);
    // `entry.horizon_id` сьогодні завжди NULL — `SqlEntryRepo` його не пише
    // взагалі. Рядок стоїть тут навмисно: той, хто колись почне писати цей
    // стовпець, не має успадкувати мовчазної діри.
    await tx.exec("UPDATE entry SET horizon_id = ? WHERE horizon_id = ?", [to, from]);
    await tx.exec("UPDATE horizon SET id = ? WHERE id = ?", [to, from]);
}
//# sourceMappingURL=remapHorizonIds.js.map